import { useContext } from "react";
import { KycFlowContext } from "../contexts/KycFlowContext";

export const useKycFlow = () => useContext(KycFlowContext);
